export default __webpack_public_path__ + "static/media/advisor-marco.1b8f6f31.jpg";